import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { IMediaList } from "../types";

export type IMediaListQueryParameters = IPaginateable;

export type IMediaListQueryResult = IMediaList;

export const mediaListQuery: IApiQueryFunction<IMediaListQueryParameters> = ({ pagination }) => {
    return {
        method: "GET",
        url: `/media${serialize(
            {
                ...mapPagination(pagination),
            },
            true,
        )}`,
    };
};

export const useMediaListQuery = createApiQueryHook<IMediaListQueryParameters, IMediaListQueryResult>(mediaListQuery);
